// Sight Optics: shuffle in-stock products in [data-shuffle-grid] grids on each page load.
// Sold-out items (detected by a 'Sold out' badge) are always moved to the end.
(function () {
  function shuffleProductGrids() {
    document.querySelectorAll('[data-shuffle-grid]').forEach(function (grid) {
      if (grid.dataset.shuffled === 'true') return;
      var items = Array.prototype.slice.call(grid.children);
      var soldOut = [];
      var inStock = [];
      items.forEach(function (item) {
        var isSoldOut = false;
        var badges = item.querySelectorAll('.badge');
        for (var i = 0; i < badges.length; i++) {
          var text = (badges[i].textContent || '').trim().toLowerCase();
          if (text.indexOf('sold out') !== -1) {
            isSoldOut = true;
            break;
          }
        }
        if (isSoldOut) {
          soldOut.push(item);
        } else {
          inStock.push(item);
        }
      });
      for (var i = inStock.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = inStock[i];
        inStock[i] = inStock[j];
        inStock[j] = tmp;
      }
      inStock.concat(soldOut).forEach(function (item) {
        grid.appendChild(item);
      });
      grid.dataset.shuffled = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', shuffleProductGrids);
  } else {
    shuffleProductGrids();
  }
})();
